import {
  VISUALIZATION_TYPE_TO_READABLE,
  PARAMETERS_TYPENAME_TO_VISUALIZATION_TYPE,
  ParametersTypename,
} from './AnalyticsVisualizationConstants';

export function getDefaultVisualizationNameForVisualizationType(type: ParametersTypename): string {
  return `${VISUALIZATION_TYPE_TO_READABLE[PARAMETERS_TYPENAME_TO_VISUALIZATION_TYPE[type]]}`;
}
